import { Link } from 'react-router-dom';

const WHATSAPP_NUMBER = '19044019383';
const WHATSAPP_MESSAGE = encodeURIComponent(
  'Oi! Gostaria de um orçamento gratuito. / Hi! I\'d like a free estimate. Please send me details about your project.'
);
const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}?text=${WHATSAPP_MESSAGE}`;

export default function MobileStickyBar() {
  return (
    <div className="fixed bottom-0 left-0 w-full z-50 md:hidden bg-[#0d0d0d] border-t border-white/10">
      <div className="grid grid-cols-3">
        <a
          href="tel:+19044019383"
          className="flex flex-col items-center justify-center gap-1 py-3 text-white font-bold text-xs border-r border-white/10 hover:bg-white/5 transition-colors cursor-pointer"
        >
          <div className="w-5 h-5 flex items-center justify-center">
            <i className="ri-phone-fill text-[#c9a55a] text-base" />
          </div>
          Call
        </a>
        <a
          href={WHATSAPP_URL}
          target="_blank"
          rel="nofollow noopener noreferrer"
          className="flex flex-col items-center justify-center gap-1 py-3 text-white font-bold text-xs border-r border-white/10 hover:bg-[#25D366]/10 transition-colors cursor-pointer"
        >
          <div className="w-5 h-5 flex items-center justify-center">
            <i className="ri-whatsapp-line text-[#25D366] text-base" />
          </div>
          WhatsApp
        </a>
        <Link
          to="/contact"
          className="flex flex-col items-center justify-center gap-1 py-3 bg-[#c9a55a] hover:bg-[#b8944a] text-[#0d0d0d] font-black text-xs transition-colors cursor-pointer"
        >
          <div className="w-5 h-5 flex items-center justify-center">
            <i className="ri-calendar-check-line text-[#0d0d0d] text-base" />
          </div>
          Estimate
        </Link>
      </div>
    </div>
  );
}
